import { ActionsButtonItem } from '../../../../ui/components/pure/actions-button/actions-button.types';
import { Import } from '../../../../ui/components/pure/icons/Import.icon';
import { makeDefineActions } from '../../../../ui/components/pure/actions-button/actions-button.helpers';
import { Permissions } from '../../../../core/permissions/permissions.typings';

export enum UserListActions {
  ADD_USER = 'ADD_USER',
  ADD_USER_SUCCESS = 'ADD_USER_SUCCESS',
  BATCH_IMPORT = 'BATCH_IMPORT',
  BATCH_IMPORT_SUCCESS = 'BATCH_IMPORT_SUCCESS'
}

function makeUsersListActions(projectID: string): ActionsButtonItem<UserListActions>[] {
  return [
    {
      title: 'Batch import',
      Icon: Import,
      action: UserListActions.BATCH_IMPORT,
      permission: {
        action: Permissions.users.batchImport,
        projectID
      }
    }
  ];
}

export function makeDefineUsersListActions(projectID: string) {
  return makeDefineActions(makeUsersListActions(projectID));
}
